import { useNoticiasPublicas } from '../../../hooks/useNoticiasPublicas';
import Button from '../../shared/Button';
import Container from '../../shared/Container';
import NewsCard from '../../shared/NewsCard';
import styles from './NewsSection.module.css';

/** Cuántas se enseñan en el home. Es lo que cabe en la rejilla. */
const CUANTAS = 3;

export default function NewsSection() {
  // Misma fuente que la página de Noticias: estáticas más publicadas, ordenadas
  // por fecha, y al día — el hook vuelve a pedirlas cuando se publica algo
  // desde el panel.
  const { datos: noticias } = useNoticiasPublicas();

  const ultimas = noticias.slice(0, CUANTAS);

  return (
    <Container as="section" id="noticias" className={styles.section}>
      <div className={styles.headerRow}>
        <div>
          <div className={styles.eyebrow}>Actualidad</div>
          <h2 className={styles.title}>Noticias</h2>
        </div>
        <Button href="/noticias">
          Más noticias
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </Button>
      </div>
      <div className={styles.grid}>
        {ultimas.map((noticia) => (
          <NewsCard
            key={noticia.id}
            to={`/noticias/${noticia.id}`}
            image={noticia.image}
            date={noticia.date}
            title={noticia.title}
          />
        ))}
      </div>
    </Container>
  );
}
